module.exports = __webpack_public_path__ + "img/x-black.aec9b21b.svg";